
export const Data = [
  {
    type:"zh",
    content: {
      homeImg : [
        {
          indexImg:1,
          type:"img",
          urlDate:"http://116.62.38.250/image/ykb/sy/banner.jpg"
        },
        // {
        //   indexImg:2,
        //   type:"img",
        //   urlDate:"http://116.62.38.250//image/sy/lb.jpg"
        // },
        // {
        //   indexImg:3,
        //   type:"img",
        //   urlDate:"http://116.62.38.250//image/sy/lb.jpg"
        // }
      ],
      homeIntroduction:{
        imgUrl:{
          type:"img",
          urlDate:"http://116.62.38.250//image/ykb/sy/ykb.png"
        },
        text1:{
          type:"text",
          content:"苏州牙客邦医疗科技有限公司成立于2022年8月25日，位于苏州吴中经济开发区生物医药产业园内，是从事口腔激光诊疗设备的高端医疗器械制造型企业。\n" +
            "苏州牙客邦医疗科技有限公司拥有自主知识产权的全线口腔激光治疗仪，在临床具有非常明显的应用价值，在口腔软组织和硬组织的治疗上有着广泛应用。口腔激光治疗相比于传统治疗方式具有精准微创、消毒杀菌、治疗时间短和患者体验极佳等显著优势。\n" +
            "公司创始人专注口腔激光行业10年以上，对于口腔激光产品及其发展前景有深厚的理解。长期积累的顶级专家资源、广泛的销售网络和深厚的客户基础，都为自有产品上市后的成功商业化打下坚实基础。\n" +
            "公司全资子公司微创未来（北京）激光技术有限公司2014年成立于北京，拥有众多自主知识产权，与国内外众多知名院校开展深入合作，专家顾问团队均来自国内顶级医疗团队。\n" +
            "2023年初牙客邦顺利完成pre-A轮融资，本轮融资由吴中生物医药产业发展基金领投，中能南方（深圳）资本集团跟投。\n" +
            "苏州牙客邦医疗科技有限公司致力于“让患者看牙更舒适不恐惧，助医生治牙更安全又高效”，积极推进产品布局，力争成为口腔激光治疗设备的全球领导品牌。"
        },
        text2:{
          type:"text",
          content:"关于牙客邦"
        },
        text3:{
          type:"text",
          content:"了解我们如何更好地"
        },
        text4:{
          type:"text",
          content:"为客户创造价值"
        },
        text5:{
          type:"text",
          content:"查看详情"
        }

      },
      homeProduct:{
        img:[
          {
            indexData:{
              type:"",
              content:1
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs1.jpg"
            },
            itemText1: {
              type:"text",
              content:"口腔Er:YAG激光治疗仪"
            },
            itemText2: {
              type:"text",
              content:""
            },

          },
          {
            indexData:{
              type:"",
              content:2
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs2.jpg"
            },
            itemText1: {
              type:"text",
              content:"工作尖"
            },
            itemText2: {
              type:"text",
              content:""
            },


          },
          {
            indexData:{
              type:"",
              content:3
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs3.jpg"
            },
            itemText1: {
              type:"text",
              content:"激光全能手机"
            },
            itemText2: {
              type:"text",
              content:""
            },


          },
          // {
          //   indexData:{
          //     type:"",
          //     content:4
          //   },
          //   imgUrl:{
          //     type: "img",
          //     urlDate: "http://116.62.38.250//image/sy/lb.jpg"
          //   },
          //   itemText1: {
          //     type:"text",
          //     content:"CCCCe"
          //   },
          //   itemText2: {
          //     type:"text",
          //     content:"4K 三mddjd光摄像系统"
          //   },

          // }
        ],
        text2:{
          type:"text",
          content:"产品技术"
        },
        text3:{
          type:"text",
          content:"探索微创科技，助力舒适高效的口腔治疗体验。"
        },
        text4:{
          type:"text",
          content:""
        }

      },
      homeProgramme:{
        img:[
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/zs.jpg"
            },
            itemText1: {
              type:"text",
              content:"针对医院"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dyy"
            }

          },
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/ys.jpg"
            },
            itemText1: {
              type:"text",
              content:"针对医生"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dys"
            }

          },
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/hz.jpg"
            },
            itemText1: {
              type:"text",
              content:"针对患者"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dhz"
            }

          }
        ],
        text2:{
          type:"text",
          content:"解决方案"
        },
        text3:{
          type:"text",
          content:"建设全国领先的口腔舒适化激光诊疗中心"
        },
        text4:{
          type:"text",
          content:""
        }

      },
      homeNews:{
        text1:{
          type:"text",
          content:"新闻公告"
        },
        text2:{
          type:"text",
          content:"关注我们的最新动态"
        },
        content1:{
          imgDate:{
            type:"img",
            content:"http://116.62.38.250//image/ykb/sy/new/ljrw.png"
          },
          text1:{
            type:"text",
            content:"2024年9月11日"
          },
          text2:{
            type:"text",
            content:"双项领军人才计划加持，牙客邦口腔Er:YAG激光治疗仪引领口腔治疗新风潮！"
          },
          path:{
            type:"text",
            content:"ljrc"
          }
        },
        content2:{
          imgDate:{
            type:"img",
            content:"http://116.62.38.250//image/ykb/sy/new/db.jpg"
          },
          text1:{
            type:"text",
            content:"2024年3月20日"
          },
          text2:{
            type:"text",
            content:"2024年东北国际口腔展隆重开幕，微创未来邀请您相约沈阳！"
          },
          path:{
            type:"text",
            content:"db"
          }
        },
        content3:{
          imgDate:{
            type:"text",
            content:""
          },
          text1:{
            type:"text",
            content:"2024年04月08日"
          },
          text2:{
            type:"text",
            content:"喜报！国内口腔Er:YAG激光治疗仪获批，成功填补国内该领域空白"
          }
        },
        path:{
          type:"text",
          content:"xb"
        }
      },
      homeLeave:{
        text1:{
          type:"",
          content:"留言反馈"
        },
        text2:{
          type:"",
          content:"为您提供咨询服务，与您一起提升口腔激光医学水平"
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"姓名",
        text2:"您的手机号",
        text3:"您的微信",
        text4:"留下您的建议和意见",
        commit:"提交"
      }
    }


  },
  {
    type:"en",
    content: {
      homeImg : [
        {
          indexImg:1,
          type:"img",
          urlDate:"http://116.62.38.250/image/ykb/sy/banner.jpg"
        },
        // {
        //   indexImg:2,
        //   type:"img",
        //   urlDate:"http://116.62.38.250//image/sy/lb.jpg"
        // },
        // {
        //   indexImg:3,
        //   type:"img",
        //   urlDate:"http://116.62.38.250//image/sy/lb.jpg"
        // }
      ],
      homeIntroduction:{
        imgUrl:{
          type:"img",
          urlDate:"http://116.62.38.250//image/ykb/sy/ykb.png"
        },
        text1:{
          type:"text",
          content:"Suzhou Yacob Medical Technology Co., Ltd. was established on August 25, 2022, and is located within the Biomedical Industrial Park of Suzhou Wuzhong Economic Development Zone. It is a high-end medical device manufacturing enterprise specializing in oral laser diagnosis and treatment equipment.\n" +
            "\n" +
            "Suzhou Yacob Medical Technology Co., Ltd. owns a full line of oral laser therapy devices with independent intellectual property rights, which have significant clinical application value and are widely used in the treatment of oral soft tissues and hard tissues. Compared with traditional treatment methods, oral laser treatment has remarkable advantages such as precision, minimally invasiveness, disinfection and sterilization, short treatment time, and excellent patient experience.\n" +
            "\n" +
            "The founder of the company has been focusing on the oral laser industry for more than 10 years and has a profound understanding of oral laser products and their development prospects. The top expert resources accumulated over the long term, the extensive sales network, and the solid customer base have all laid a solid foundation for the successful commercialization of the company's own products after they are launched on the market.\n" +
            "\n" +
            "The company's wholly-owned subsidiary, Micro-invasive Future (Beijing) Laser Technology Co., Ltd., was established in Beijing in 2014. It has a large number of independent intellectual property rights, conducts in-depth cooperation with many well-known domestic and foreign universities, and its expert advisory team members all come from top domestic medical teams.\n" +
            "\n" +
            "In early 2023, Yacob successfully completed the pre-A round of financing. This round of financing was led by the Wuzhong Biomedical Industry Development Fund, and Zhongneng Southern (Shenzhen) Capital Group participated as a follow-on investor.\n" +
            "\n" +
            "Suzhou Yacob Medical Technology Co., Ltd. is committed to \"making dental treatment more comfortable and less terrifying for patients, and helping dentists treat teeth more safely and efficiently\". It actively promotes the product layout and strives to become a global leading brand in oral laser treatment equipment."
        },
        text2:{
          type:"text",
          content:"About Yacob"
        },
        text3:{
          type:"text",
          content:"Learn how we create greater value for our customers."
        },
        text4:{
          type:"text",
          content:""
        },
        text5:{
          type:"text",
          content:"查看详情"
        }

      },
      homeProduct:{
        img:[
          {
            indexData:{
              type:"",
              content:1
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs1.jpg"
            },
            itemText1: {
              type:"text",
              content:"Er:YAG Dental Laser Instrument"
            },
            itemText2: {
              type:"text",
              content:""
            },

          },
          {
            indexData:{
              type:"",
              content:2
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs2.jpg"
            },
            itemText1: {
              type:"text",
              content:"Working Tip"
            },
            itemText2: {
              type:"text",
              content:""
            },


          },
          {
            indexData:{
              type:"",
              content:3
            },
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/cpjs/cpjs3.jpg"
            },
            itemText1: {
              type:"text",
              content:"All-purpose Laser Handpiece"
            },
            itemText2: {
              type:"text",
              content:""
            },


          },
          // {
          //   indexData:{
          //     type:"",
          //     content:4
          //   },
          //   imgUrl:{
          //     type: "img",
          //     urlDate: "http://116.62.38.250//image/sy/lb.jpg"
          //   },
          //   itemText1: {
          //     type:"text",
          //     content:"CCCCe"
          //   },
          //   itemText2: {
          //     type:"text",
          //     content:"4K 三mddjd光摄像系统"
          //   },

          // }
        ],
        text2:{
          type:"text",
          content:"Product Technology"
        },
        text3:{
          type:"text",
          content:"Explore minimally invasive technology to facilitate a comfortable and efficient oral treatment experience."
        },
        text4:{
          type:"text",
          content:""
        }

      },
      homeProgramme:{
        img:[
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/zs.jpg"
            },
            itemText1: {
              type:"text",
              content:"For Hospitals"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dyy"
            }

          },
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/ys.jpg"
            },
            itemText1: {
              type:"text",
              content:"For Doctors"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dys"
            }

          },
          {
            imgUrl:{
              type: "img",
              urlDate: "http://116.62.38.250//image/ykb/sy/jjfa/hz.jpg"
            },
            itemText1: {
              type:"text",
              content:"For Patients"
            },
            itemText2: {
              type:"text",
              content:""
            },
            left:{
              type:"text",
              content:"0px"
            },
            path:{
              type:"text",
              content:"dhz"
            }

          }
        ],
        text2:{
          type:"text",
          content:"Solution"
        },
        text3:{
          type:"text",
          content:"Establish a nationally leading oral comfort laser diagnosis and treatment center."
        },
        text4:{
          type:"text",
          content:""
        }

      },
      homeNews:{
        text1:{
          type:"text",
          content:"News and Announcements"
        },
        text2:{
          type:"text",
          content:"Stay tuned for our latest updates."
        },
        content1:{
          imgDate:{
            type:"img",
            content:"http://116.62.38.250//image/ykb/sy/new/ljrw.png"
          },
          text1:{
            type:"text",
            content:"September 11, 2024"
          },
          text2:{
            type:"text",
            content:"Backed by the Dual - Leading Talents Program, the Yacob Er:YAG Dental Laser Instrument ushers in a new trend in oral treatment!"
          },
          path:{
            type:"text",
            content:"ljrc"
          }
        },
        content2:{
          imgDate:{
            type:"img",
            content:"http://116.62.38.250//image/ykb/sy/new/db.jpg"
          },
          text1:{
            type:"text",
            content:"March 20, 2024"
          },
          text2:{
            type:"text",
            content:"The 2024 Northeast International Dental Exhibition grandly opens. Victrum invites you to meet in Shenyang!"
          },
          path:{
            type:"text",
            content:"db"
          }
        },
        content3:{
          imgDate:{
            type:"text",
            content:""
          },
          text1:{
            type:"text",
            content:"April 8, 2024"
          },
          text2:{
            type:"text",
            content:"Congratulations! The domestic Er:YAG Dental Laser Instrument has been approved, successfully filling the gap in this field in China."
          }
        },
        path:{
          type:"text",
          content:"xb"
        }
      },
      homeLeave:{
        text1:{
          type:"",
          content:"Message and Feedback"
        },
        text2:{
          type:"",
          content:"We provide you with consultation services and work together with you to enhance the level of oral laser medicine."
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"Name",
        text2:"Mobile Phone Number",
        text3:"WeChat ID",
        text4:"Please leave your suggestions and opinions.",
        commit:"Submit"
      }
    }


  }
];



// WEBPACK FOOTER //
// ./src/components/js/home.js